import seodata from '@/data/seometadata.json'
import BlogAuthorsdatas from '@/data/blogauthors.json'

const AllPagesSEOData = seodata;
const BlogAuthorsdata = BlogAuthorsdatas;

const fetchData = async (slug = null) => {
    let fetchedData = [];
    const res = await fetch("/api/mdx-files");
    const apidata = await res.json();

    const allBlogs = apidata[0]?.blogs || [];

    if (slug) {
        const matchedBlog = allBlogs.find(blog => blog.slug === slug);
        return matchedBlog || null;
    }

    fetchedData = allBlogs;
    return allBlogs;
};

// const fetchFAQBySlug = (slug: string) => {
//     const matchedPage = AllPagesSEOData.find(
//         page => page.page_title?.toLowerCase().replace(/\s+/g, "-") === slug
//     );

//     return matchedPage?.faq || [];
// };

const fetchFAQBySlug = (slug: string) => {
    const matchedPage = AllPagesSEOData.find(
        page => page.page_title?.toLowerCase().replace(/\s+/g, "-") === slug
    );

    return matchedPage?.faq || AllPagesSEOData.find(
        page => page.page_title?.toLowerCase().replace(/\s+/g, "-") === 'home'
    )?.faq || [];
};

const PagejsonLd = {
    "@context": "https://www.schema.org",
    "@type": "Organization",
    "name": "JBcodeapp",
    "url": "https://jbcodeapp.com/",
    "sameAs": [
        "https://www.linkedin.com/in/jbcodeapp",
        "https://twitter.com/jbcodeapp",
        "https://www.facebook.com/jbcodeapp",
        "https://www.instagram.com/jbcodeapp",
        "https://www.youtube.com//@jbcodeapp"
    ],
    "description": "JBcodeapp offers innovative software, web, and mobile app development solutions. Boost your business with our tailored digital services and expert developers.",
    "address": {
        "@type": "PostalAddress",
        "streetAddress": "536, 5 Square Point,",
        "postOfficeBoxNumber": "RANDER",
        "addressLocality": "Surat",
        "addressRegion": "Gujarat",
        "postalCode": "395005",
        "addressCountry": "IN"
    },
    "geo": {
        "@type": "GeoCoordinates",
        "latitude": "21.229726791381836",
        "longitude": "72.78727722167969"
    },
    "hasMap": "https://maps.app.goo.gl/Z9eH1vt8rjYeyHSz8",
    "openingHours": "Mo 08:00-21:00 Tu 08:00-21:00 We 08:00-21:00 Th 08:00-21:00 Fr 08:00-21:00 Sa 08:00-18:00"
};

export {
    AllPagesSEOData,
    BlogAuthorsdata,
    fetchData,
    fetchFAQBySlug,
    PagejsonLd
}